import { motion } from 'framer-motion';
import computerIcon from '../assets/icons/computer.png';
import linkedinIcon from '../assets/icons/linkedin.png';
import githubIcon from '../assets/icons/github-sign.png';
import xIcon from '../assets/icons/twitter.png';
import profile from '../assets/images/GPT-Ghibili-image.png';
import { TextShimmer } from './ui/text-shimmer';
import { ContainerScroll } from './ui/container-scroll-animation';

const roles = [
  { title: 'Software Engineer Intern', org: 'Tesla' },
  { title: 'Staff Software Engineer', org: 'Daily Bruin' },
  { title: 'IT Support', org: 'UCLA Social Sciences Center' },
  { title: 'AI/ML Fellow', org: 'Break Through Tech' },
];

const funFacts = ['Team USA Taekwondo', 'Matcha obsessed', 'Piano for 7 years', 'Sneaker reseller', 'Food lover'];

const socials = [
  { href: 'https://github.com/anthonysk0215', icon: githubIcon, label: 'GitHub' },
  { href: 'https://www.linkedin.com/in/anthonydo6/', icon: linkedinIcon, label: 'LinkedIn' },
  { href: 'https://x.com/anthony_ddo', icon: xIcon, label: 'X' },
];

export default function HomeContent() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 70 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      className="flex flex-col overflow-hidden mt-0"
    >
      <div className="mt-0 md:mt-6">
        <ContainerScroll
          titleComponent={
            <>
              <h1 className="text-4xl md:text-4xl font-semibold text-black dark:text-white mb-0 md:-mt-12">
                Hi, I'm <br />
                <TextShimmer
                  duration={4}
                  className="text-6xl md:text-[6rem] font-helvetica mt-0 md:mt-1 leading-[1.1] [--base-color:theme(colors.blue.500)] [--base-gradient-color:theme(colors.blue.200)] dark:[--base-color:theme(colors.blue.700)] dark:[--base-gradient-color:theme(colors.blue.400)]"
                >
                  Anthony Do
                </TextShimmer>
              </h1>
            </>
          }
        >
          <div className="flex flex-col md:flex-row h-full w-full items-center gap-8 md:gap-14 p-5 md:p-10">
            {/* Left content - Intro, current roles, fun facts */}
            <div className="flex-1 space-y-8 md:space-y-10">
              <p className="text-base md:text-lg leading-relaxed text-gray-600 dark:text-gray-300">
                I'm an undergraduate student at the University of California, Los Angeles studying Computer Science, Data Science, and Linguistics.
              </p>

              <div className="space-y-3">
                <div className="flex items-center gap-2">
                  <img src={computerIcon} alt="" className="w-4 h-4 object-contain opacity-60" />
                  <span className="text-xs font-medium uppercase tracking-widest text-gray-400 dark:text-gray-500">
                    Currently
                  </span>
                </div>
                <ul className="space-y-1.5">
                  {roles.map((role) => (
                    <li key={role.org} className="text-sm md:text-base leading-snug">
                      <span className="text-gray-800 dark:text-gray-200">{role.title}</span>
                      <span className="text-gray-400 dark:text-gray-600"> · </span>
                      <span className="text-gray-500 dark:text-gray-400">{role.org}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="space-y-3">
                <span className="text-xs font-medium uppercase tracking-widest text-gray-400 dark:text-gray-500">
                  Off the clock
                </span>
                <div className="flex flex-wrap gap-2">
                  {funFacts.map((fact) => (
                    <span
                      key={fact}
                      className="rounded-full border border-gray-200 dark:border-gray-700 px-3 py-1 text-xs md:text-sm text-gray-600 dark:text-gray-400"
                    >
                      {fact}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Right content - Profile image and social links */}
            <div className="flex flex-row md:flex-col items-center gap-4 md:gap-6 w-full md:w-auto">
              <div className="w-28 h-28 md:w-56 md:h-56 rounded-full overflow-hidden flex-shrink-0 ring-1 ring-gray-200 dark:ring-gray-700">
                <img src={profile} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="flex flex-col md:flex-row gap-2 w-full md:w-auto">
                {socials.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 rounded-full border border-gray-200 dark:border-gray-700 px-3 py-2 text-xs md:text-sm text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 hover:border-gray-300 dark:hover:border-gray-600 transition-colors duration-200"
                  >
                    <img src={social.icon} alt="" className="w-4 h-4 object-contain" />
                    <span>{social.label}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </ContainerScroll>
      </div>
    </motion.div>
  );
}
